module.exports = __webpack_public_path__ + "static/img/4.0604e694.jpg";